import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import validations from 'validations';
import TextAreaField from 'components/TextAreaField';
import InputField from 'components/InputField';
import { UserEnquiryContextValues } from 'models/UserEnquiryContext';

import './UserEnquiryForm.styles.scss';

export const CONTEXT_ROWS = '5';
export const CONTEXT_MAX_LENGTH = 1000;

type UserEnquiryFormProps = {
  className?: string;
  cancelButtonText?: string;
  submitButtonText?: string;
  initialValues?: UserEnquiryContextValues;
  onCancel: () => void;
  onSubmit: (values: UserEnquiryContextValues) => void;
};

const UserEnquiryForm: React.FC<UserEnquiryFormProps> = (props) => {
  const {
    className,
    cancelButtonText,
    submitButtonText,
    initialValues,
    onCancel,
    onSubmit,
  } = props;

  const classes = classNames('user-enquiry-form', className);

  const { t } = useTranslation();

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} className={classes}>
          <Field
            name="tag"
            component={InputField}
            label={t('label')}
            placeholder={t('contextLabelPlaceholder')}
            required
            validate={validations.required()}
          />

          <Field
            name="description"
            component={TextAreaField}
            label={t('context')}
            placeholder={t('contextDescriptionPlaceholder')}
            rows={CONTEXT_ROWS}
            maxLength={CONTEXT_MAX_LENGTH}
            required
            validate={validations.composeValidators(
              validations.required(),
              validations.maxChars(CONTEXT_MAX_LENGTH),
            )}
          />

          <div className="actions">
            <Button variant="link" onClick={onCancel}>
              {cancelButtonText || t('cancel')}
            </Button>
            <Button type="submit" disabled={submitting}>
              {submitButtonText || t('save')}
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default UserEnquiryForm;
